/** @jsxImportSource @emotion/react */

import { CoreButton, CoreProps } from './CoreButton';

export type Variant = 'primary' | 'secondary' | 'text' | 'icon' | 'tertiary';

export type Props = Omit<CoreProps, 'utility' | 'ref'>;

export const Button = (props: Props) => <CoreButton {...props} />;
